// @flow
import React from "react";
import MuiThemeProvider from "@material-ui/core/styles/MuiThemeProvider";

import { LightTheme } from "../../global/uis/themes";
import ErrorBoundary from "../../global/containers/ErrorBoundary";

const PageContainer = (props: *): * => {
  return (
    <MuiThemeProvider theme={LightTheme}>
      <div className="mui-form">
        <ErrorBoundary>
          {props.children}
        </ErrorBoundary>
      </div>
    </MuiThemeProvider>
  );
};

export default PageContainer;
